import { render, staticRenderFns } from "./Userchoosetool.vue?vue&type=template&id=22982024&scoped=true"
import script from "./Userchoosetool.vue?vue&type=script&lang=js"
export * from "./Userchoosetool.vue?vue&type=script&lang=js"
import style0 from "./Userchoosetool.vue?vue&type=style&index=0&id=22982024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22982024",
  null
  
)

export default component.exports